import { HttpService } from "@/core";
export const post = () => {
  const api = (url, data: any = {}) =>
    HttpService.axios({
      method: "POST",
      url,
      data,
    });
  return HttpService.useRequest<any>(api);
};
export const warehouseCount = () => {
  const api = () =>
    HttpService.axios({
      method: "GET",
      url: '/manage_warehouse/list/warehouseCount',
    });
  return HttpService.useRequest<any>(api);
};
export const projectCount = () => {
  const api = () =>
    HttpService.axios({
      method: "GET",
      url: '/manage_warehouse/list/manageProjectCount',
    });
  return HttpService.useRequest<any>(api);
};
